import { APIService } from '../app/Services/API-Service/api-service';
import { PermissionsService } from '../app/Services/Permissions-Service/permissions-service';

export const environment = {
  production: true,
  IAPIService: APIService,
  baseUrl: "http://www.rp.com",
  rootPath: "ELearning/",
  imagePath: "scripts/AngularELearning/"
};
